import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegionStorageService {
  storageKey = "region";
  constructor() { }

  storeRegion(region) {
    localStorage.setItem(this.storageKey, region);
  }

  loadRegion() {
    return localStorage.getItem(this.storageKey);
  }

  clear() {
    localStorage.removeItem(this.storageKey);
  }

 
}
